import ProTip from './ProTip';
export default ProTip;